import { Subject } from 'rxjs';

import { UserContextService } from '../context/user.context.service';
import { WhoAmI } from '../model/user/whoAmI.model';
import { AuthorityUtil } from '../util/authority.util';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export class WalletBaseRoleService {
    private _userOrgId!: string;
    private _isAdmin!: boolean;
    private _isInternal!: boolean;
    private _isCustomer!: boolean;
    private _canRead!: boolean;
    private _hasGatewayRead!: boolean;
    private _hasGatewayPay!: boolean;
    private _canTopUp!: boolean;

    protected $destroy: Subject<void> = new Subject();

    constructor(
        private userContextService: UserContextService,
        private adminPermission: string,
        private internalPermission: string,
        private readPermission: string
    ) {
        this.userContextService
            .getContext()
            .pipe(takeUntilDestroyed())
            .subscribe((userContext: WhoAmI | null) => {
                if (!userContext) return;

                this._userOrgId = userContext.getOrgId();
                this._isAdmin = userContext.hasAuthority(this.adminPermission);
                this._isInternal = userContext.hasAuthority(this.internalPermission);
                this._canRead = userContext.hasAuthority(this.readPermission);
                this._isCustomer = this._canRead && !this._isInternal;
                this._hasGatewayRead = userContext.hasAuthority(AuthorityUtil.PERMISSION_PAYMENT_GATEWAY_READ);
                this._hasGatewayPay = userContext.hasAuthority(AuthorityUtil.PERMISSION_PAYMENT_GATEWAY_PAY);
                this._canTopUp = userContext.hasAuthority(AuthorityUtil.PERMISSION_WALLET_TOP_UP);
            });
    }

    public get isAdmin(): boolean {
        return this._isAdmin;
    }

    public get isInternal(): boolean {
        return this._isInternal;
    }

    public get isCustomer(): boolean {
        return this._isCustomer;
    }

    public get canRead(): boolean {
        return this._canRead;
    }

    public get userOrgId(): string {
        return this._userOrgId;
    }

    public get hasGatewayRead(): boolean {
        return this._hasGatewayRead;
    }

    public get hasGatewayPay(): boolean {
        return this._hasGatewayPay;
    }

    public get canTopUp(): boolean {
        return this._canTopUp;
    }
}
